// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__5GJPc","label":"Category_label__23_8T","content":"Category_content__1TJyg","header":"Category_header__1cnxB","location":"Category_location__1vhrS"};